import axios from '@/libs/http'

/**
 * 获取自定义列
 * */
export const getTable = (name) => {
    let data = new URLSearchParams()
    data.append("name", name)
    return axios.request({
        url: '/s/custom-table/getTable',
        data,
        method: 'post'
    })
}

